import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import Guid from "_shared/guids/guid";
import NotificationTopicSchema, {
  NotificationTopicJSON,
  NotificationTopicParams,
} from "notifications/values/notification-topic/notification-topic-schema";

export default class NotificationTopic {
  public static create(values: NotificationTopicParams): NotificationTopic {
    const parsed = NotificationTopicSchema.validateParams(values);
    return new NotificationTopic(parsed);
  }

  public static fromJSON(value: unknown): NotificationTopic | null | undefined {
    if (isNullOrUndefined(value)) return value;
    const parsed = NotificationTopicSchema.deserialize(value);
    return new NotificationTopic(parsed);
  }

  public readonly category?: string;
  public readonly id?: Guid | null;

  public toJSON(): NotificationTopicJSON {
    return NotificationTopicSchema.serialize(this);
  }

  public isEqualTo(other: NotificationTopic): boolean {
    const sameCategory =
      (this.category === undefined && other.category === undefined) ||
      (this.category !== undefined && other.category !== undefined && this.category === other.category);

    const a = this.id;
    const b = other.id;

    const sameId = (a === null && b === null) || (a === undefined && b === undefined) || (!!a && !!b && a.isEqualTo(b));

    return sameCategory && sameId;
  }

  public toString(): string {
    return `${this.category ?? "null"} [${this.id?.value ?? "null"}]`;
  }

  public constructor(values: NotificationTopicParams) {
    NotificationTopicSchema.validateParams(values);
    this.category = values.category;
    this.id = values.id ?? null;
  }
}
